import { ApiEndpointSpecification } from './types';
import { HttpMethod } from '../http-request';
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';
import { TREND_DEVICE_EXPORT } from './url-constants';

type TrendDeviceExportEndpointSpecification = ApiEndpointSpecification;
export const TrendDeviceExportEndpointSpecification: TrendDeviceExportEndpointSpecification = {
    url: TREND_DEVICE_EXPORT,
    method: HttpMethod.POST,
    requestParamsSchemaName: 'TrendDeviceExportRequestParams',
    requestBodySchemaName: 'TrendDeviceExportRequestBody',
    okResponseSchemaName: 'TrendDeviceExportOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: true,
};

export const invokeTrendDeviceExport = Helpers.makeApiRequestFn<
    Types.TrendDeviceExportRequestParams,
    Types.TrendDeviceExportRequestBody,
    Types.TrendDeviceExportOkResponse
>(TrendDeviceExportEndpointSpecification);
